/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BatteryLookupTableData } from './BatteryLookupTableData';
import type { BatteryState } from './BatteryState';
/**
 * Battery in Database.
 */
export type BatteryLookupTableInDB = {
    item_type?: BatteryLookupTableInDB.item_type;
    name?: string;
    mass?: number;
    moment_of_inertia?: number;
    cost?: number;
    component_type?: 'BatteryLookupData';
    lookup_table: BatteryLookupTableData;
    state?: BatteryState;
    _id?: string;
};
export namespace BatteryLookupTableInDB {
    export enum item_type {
        COMPONENT = 'component',
    }
}

